import { Client } from '@stomp/stompjs';

const stompClientMP = new Client({
  brokerURL: window.config.RMQMessagePublisherConfig.URL,
  connectHeaders: {
    login: window.config.RMQMessagePublisherConfig.User,
    passcode: window.config.RMQMessagePublisherConfig.Pass,
    host: window.config.RMQMessagePublisherConfig.VirtualHost,
  },
  // debug: function (str) {
  //   console.log("[STOMP DEBUG]:", str);
  // },
  reconnectDelay: 5000,
  heartbeatIncoming: 10000,
  heartbeatOutgoing: 10000,
});

export default stompClientMP;
